import React from 'react';
import { Box, Chip, ChipProps } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { candidateProfileChipSx } from 'modules/candidate-profile/styles';

type CandidateProfileChipProps = {
  prefix?: string;
  label: string;
  isNegative?: boolean;
  onDelete?: () => void;
  onClick?: () => void;
  size?: ChipProps['size'];
  maxWidth?: number;
  wrap?: boolean;
  'aria-label'?: string;
};

export const CandidateProfileChip: React.FC<CandidateProfileChipProps> = ({
  prefix,
  label,
  isNegative = false,
  onDelete,
  onClick,
  size,
  maxWidth,
  wrap = false,
  'aria-label': ariaLabel
}) => (
  <Chip
    variant="outlined"
    size={size}
    onClick={onClick}
    onDelete={onDelete}
    // MUI defaults to the filled CancelIcon; the theme override does not reach it.
    deleteIcon={onDelete ? <CloseIcon /> : undefined}
    aria-label={ariaLabel ?? (prefix ? `${prefix} ${label}` : label)}
    label={
      prefix ? (
        <>
          <Box component="strong" sx={candidateProfileChipSx.prefix}>
            {prefix}
          </Box>{' '}
          {label}
        </>
      ) : (
        label
      )
    }
    sx={[
      candidateProfileChipSx.chip,
      isNegative && candidateProfileChipSx.excludeChip,
      maxWidth !== undefined && candidateProfileChipSx.withMaxWidth(maxWidth),
      wrap && candidateProfileChipSx.wrapping
    ]}
  />
);
